<div class="f-col my-14 my-md-8 d-align-center">
    <h2 class="title-text">{{content?.['b2b.booking.saudiabusiness']}}</h2>
    <p class="titleTextSub m-top-8x">{{content?.['b2b.booking.convenient']}}</p>

</div>